import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/layout.css";
import "../css/login.css";
import findGif from "../css/loading_old.gif";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from '../../apiService/allApi'

export default function Login() {
  const history = useHistory();
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
    const [time, setTime] = useState(new Date());

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const handleClick = async (e) => {

    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true);
      const time = new Date()
      let newTime = time.toString()

      try {
        const respone = await apiRequest(`login`, "POST", { Phone, referral, newTime }, null)
        if (respone) {
          setIsloading1(false);
          if (respone.data.status == 101) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: respone.data.msg,
            });
          } else if (respone.data.status == 200) {
            setOtp(true);
            setSecretCode(respone.data.secret);
            if (respone.data.myToken) {
              Swal.fire({
                icon: "success",
                title: "OTP",
                text: "Demo Account Testing OTP: " + respone.data.myToken,
              });
            }
          }
          else if (respone?.data?.msg == 'Currently we are not allowing new registration.') {
            Swal.fire({
              icon: "warning",
              title: "Important Notice",
              html: `
                <p style="font-size:14px; color:#333; margin-bottom:15px;">
                 As per recent development pertaining to 
               <b>"The Promotion and Regulation of Online Gaming Bill, 2025"</b>, 
                we are pausing all operations as of now. We shall inform you till any update.
                 </p>

               <div style="background:#e6f9ec; color:#006600; padding:10px; border-radius:6px; margin-bottom:10px; font-size:13px;">
               ✅ Your amount is safe with us. You can withdraw all your winning directly to your Bank account.
               </div>

                <div style="background:#f0f6ff; color:#004080; padding:10px; border-radius:6px; font-size:13px;">
                ℹ️ Further money in your deposit wallet will be made available within 48 hours in your winning wallet for withdrawals.
                </div>
               `,
              background: "#fff",
              color: "#000",
              showCloseButton: true,
              confirmButtonText: "I Understand",
              confirmButtonColor: "#006633", // green button
              customClass: {
                popup: "rounded-xl shadow-lg p-3",
                title: "text-lg font-bold mb-2",
                confirmButton: "px-6 py-2 rounded-lg font-medium"
              }
            });
          }
          else if (respone?.data?.msg == "Currently we are not allowing user to Login") {
            Swal.fire({
              icon: "info",
              title: "Important Notice",
              text: respone?.data?.msg,

            });
          }
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
        });
      }
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();

    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }
    setIsloading1(true);

    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode }, null)
      setIsloading1(false);

      if (response.data.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.msg,
        });
      } else if (response.data.status === 200) {
        const token = response.data.token;
        localStorage.setItem("token", token);
        // Reload the page and redirect after a delay
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games"); // Assuming you have 'history' available
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!" + response.data.status + "",
        });
      }

    }
    catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    }
  };

  // otp valid
  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;

    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true); // Show the Resend button when OTP expires
      setIsValid(false);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false); // Hide the Resend button after clicking it
  };
  return (
    <>
      <div className="leftContainer" style={{ minHeight: "100vh" , backgroundImage: `url('/images/bcback.jpg')` , backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="unique-login-container">
          {/* Side Decorative Element */}
          <div className="side-accent"></div>

          <div className="main-auth-card">
            <div className="auth-inner">
              <header className="auth-intro">
                <picture class="justify-content-center Nav_navLogo__BgOil d-flex"><img src="/images/manna_co.png" class="snip-img logo3d" alt="maantLudo" width="30px"/></picture>
            
              </header>

              <div className="auth-fields-group">
                {/* Phone Input */}
                <div className="neo-input-box">
                  <input
                    name="mobile"
                    type="tel"
                    required
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  <label>Mobile (+91)</label>
                  <div className="focus-border"></div>
                </div>

                {/* OTP Input with Logic */}
                {otp && (
                  <div className="otp-wrapper-animate">
                    <div className="neo-input-box">
                      <input
                        name="password"
                        type="tel"
                        required
                        onChange={(e) => settwofactor_code(e.target.value)}
                      />
                      <label>Enter OTP</label>
                      <div className="focus-border-otp"></div>
                    </div>

                    <div className="otp-footer">
                      {isValid || seconds !== 0 ? (
                        <span className="timer-count">
                          Resend in <b>{seconds}s</b>
                        </span>
                      ) : (
                        showResend && (
                          <button
                            className="text-action-btn"
                            onClick={handleResendClick}
                          >
                            Get New Code
                          </button>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Button Logic Container */}
              <div className="auth-actions">
                {!otp ? (
                  <button
                    className={`glow-btn ${isLoading1 ? "active-loading" : ""}`}
                    onClick={(e) => {
                      handleClick(e);
                      setIsValid(true);
                    }}
                    disabled={isLoading1}
                  >
                    {isLoading1 ? (
                      <span className="loader-dots"></span>
                    ) : (
                      "Send Otp"
                    )}
                  </button>
                ) : (
                  <button
                    className={`glow-btn verify-mode ${
                      isLoading1 ? "active-loading" : ""
                    }`}
                    onClick={(e) => varifyOtp(e)}
                    disabled={isLoading1}
                  >
                    {isLoading1 ? (
                      <span className="loader-dots"></span>
                    ) : (
                      "Verify & Access"
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
